<template>
	<circle-button :icon="icon" :color="color" :title="title" @click="toggle" :class="{rotation: value && rotate}"/>
</template>

<script>
export default {
	props: ['value', 'title', 'icon', 'color', 'rotate'],
	methods: {
		toggle($event) {
			this.$emit('input', !this.value);
			this.$emit('click', !this.value);
		}
	}
}
</script>

<style>
.rotation {
  transform: rotateZ(90deg);
}
</style>


// WEBPACK FOOTER //
// src/components/shared/CircleToggler.vue